module.exports = __webpack_public_path__ + "static/img/niushe2.af10fc29.png";